import React, { useEffect } from "react";
import "./SidePanel.css";

interface SidePanelProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  width?: string;
  footer?: React.ReactNode;
  children: React.ReactNode;
}

export function SidePanel({ isOpen, onClose, title, width, footer, children }: SidePanelProps) {
  useEffect(() => {
    const handleEsc = (e: KeyboardEvent) => {
      if (e.key === "Escape") onClose();
    };
    if (isOpen) document.addEventListener("keydown", handleEsc);
    return () => document.removeEventListener("keydown", handleEsc);
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  return (
    <div className="protrain-sidepanel-overlay" onClick={onClose}>
      <div
        className="protrain-sidepanel"
        style={{ width: width || "480px" }}
        onClick={(e) => e.stopPropagation()}
        role="dialog"
        aria-modal="true"
        aria-label={title}
      >
        <div className="protrain-sidepanel-header">
          <h2 className="protrain-sidepanel-title">{title}</h2>
          <button className="protrain-sidepanel-close" onClick={onClose} aria-label="Close panel">✕</button>
        </div>
        <div className="protrain-sidepanel-body">{children}</div>
        {footer && <div className="protrain-sidepanel-footer">{footer}</div>}
      </div>
    </div>
  );
}
